import { ModelMixin } from '../core/base-generic.model';
import { InterviewQuestion } from './interview-question.model';

/**
 * This model only has an update endpoint
 */
export class ApplicantInterviewerFeedback extends ModelMixin<ApplicantInterviewerFeedback>() {
    protected static _resource = 'applicantTracker/applicantInterviewerFeedbacks';
    protected static _version = 'v2';
    protected static _serializeAttributes = ['feedback'];
    protected static _datetimes = ['createdAt', 'updatedAt', 'deletedAt'];

    get atsApplicantInterviewerId(): number {
        return this._attributes['atsApplicantInterviewerId'];
    }

    get atsInterviewQuestionId(): number {
        return this._attributes['atsInterviewQuestionId'];
    }

    get feedback(): string[] {
        return this._attributes['feedback'];
    }

    set feedback(val: string[]) {
        this._attributes['feedback'] = val;
    }

    get interviewQuestion(): InterviewQuestion {
        return this.hasOne(InterviewQuestion, 'interviewQuestion');
    }
}
